import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { concatMap, skip } from "rxjs/operators";
import { OrderResolver } from '../../resolvers/order.resolver';
import { MsAuthService } from '../../services/ms-auth.service';
import { IOrder, SaleService } from '../../services/sale.service';
import { Sale } from '../../models/sale.model';


@Component({
  selector: 'order-item-summary-page',
  templateUrl: './order-item-summary-page.component.html',
  styleUrls: ['./order-item-summary-page.component.scss'],
})
export class OrderItemSummaryPageComponent implements OnInit, OnDestroy {
  public sale: Sale | undefined;
  public itemIndex = 0;
  private _subscriptions = new Subscription();

  constructor(
      private _route: ActivatedRoute,
      private _router: Router,
      private _msAuthService: MsAuthService,
      private _orderResolver: OrderResolver,
      private _saleService: SaleService
  ) {}

  ngOnInit(): void {
    this._subscriptions.add(
        this._msAuthService.loggedIn$
            .pipe(
                skip(1),
                concatMap((..._) => {
                    this._saleService.resetSales();
                    return this._orderResolver.resolve(this._route.snapshot);
                })
            )
            .subscribe({
                next: (_) => this._fetchResolvedOrder(),
            })
    );
    this._fetchResolvedOrder();
  }

  private _fetchResolvedOrder() {
    const order = this._route.snapshot.data.order;
    if (order && order.length > 0) {
      if (order.length > 1) {
        this._router.navigateByUrl('/order-search');
      } else if (order.length === 1) {
        this.sale = this._route.snapshot.data.order[0];
        this._subscriptions.add(
          this._route.params.subscribe((params) => {
            this.itemIndex = params['itemIndex'];
          })
        );
      }
    } else {
      this._router.navigateByUrl('/client-search');
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
